import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {ContainerMaxWidth} from "models/SearchState"
import {useUrlListener} from "../../hooks/useUrlListener"
import connect from "./connect"

interface PlpContainerProps {
    children: NonNullable<React.ReactNode>
    loadPageFromUrl: (url: string) => void
    testId: string
    templating: {mainTemplate: string; fallbackTemplate: string}
    containerMaxWidth: ContainerMaxWidth
}

export const PlpContainer = memo(
    ({children, loadPageFromUrl, testId = "plp-container", templating, containerMaxWidth}: PlpContainerProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        useUrlListener(loadPageFromUrl)
        return (
            <Suspense>
                <ComponentName data-testid={testId} containerMaxWidth={containerMaxWidth}>
                    {children}
                </ComponentName>
            </Suspense>
        )
    },
)
PlpContainer.displayName = "PlpContainer"

export default connect(PlpContainer)
